import { ConversationChannel } from '@provision/entity-types';
import { gql, useMutation } from '@provision/graphql-client';
import { useCallback } from 'react';
import { Conversation } from './conversation/conversation.types';

export const CONVERSATION_CHANNEL_FIELDS = gql`
  fragment ConversationChannelFields on ConversationChannel {
    id
    partnerId
    conversationChannelTypeId
    conversationParticipantId
    externalIdentifier
    internalIdentifier
  }
`;

const CREATE_CONVERSATION_CHANNEL_MUTATION = gql`
  mutation CreateConversationChannel(
    $partnerId: Int!
    $conversationChannelTypeId: String!
    $conversationParticipantId: String!
    $externalIdentifier: String!
    $internalIdentifier: String!
  ) {
    createConversationChannel(
      data: {
        partnerId: $partnerId
        conversationChannelTypeId: $conversationChannelTypeId
        conversationParticipantId: $conversationParticipantId
        externalIdentifier: $externalIdentifier
        internalIdentifier: $internalIdentifier
      }
    ) {
      ...ConversationChannelFields
    }
  }
  ${CONVERSATION_CHANNEL_FIELDS}
`;

export const useConversationChannel = () => {
  const [createConversationChannelMutation] = useMutation<{
    createConversationChannel: { id: string }[];
  }>(CREATE_CONVERSATION_CHANNEL_MUTATION);

  const createConversationChannel = useCallback(
    async (
      data: Pick<
        ConversationChannel,
        | 'partnerId'
        | 'conversationChannelTypeId'
        | 'conversationParticipantId'
        | 'externalIdentifier'
        | 'internalIdentifier'
      > & {
        conversation: Conversation;
      },
    ) => {
      const { conversation, ...variables } = data;

      const result = await createConversationChannelMutation({
        variables,
      });

      return result.data?.createConversationChannel?.[0];
    },
    [createConversationChannelMutation],
  );

  return {
    createConversationChannel,
  };
};
